import { Route, BrowserRouter, Routes } from "react-router-dom";
import Cart from "./pages/cart";
import Home from "./pages/home";
import Orders from "./pages/orders";
import ConfirmOrder from "./pages/orders/confirmOrder";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import Snackbar from "./Components/snackbar/snackbar";
import OrderItems from "./pages/orderItems";
import NewHelmet from "./Components/Helmet/helmet";
import OrderDetails from "./pages/orderDetails";
import { useOrderSession } from "./hooks/useOrderSession";

const googleTagTrackingId = "GTM-XCFD0XL3D9";
const tagManagerArgs = {
  gtmId: googleTagTrackingId,
};

const OrderSessionSync = () => {
  useOrderSession();
  return null;
};

function App () {
  useEffect(() => {
    if ((window as any)?.location?.host?.match(/^order\.gettimart\.com$/)) {
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  return (
    <div>
      <NewHelmet />
      <BrowserRouter>
        <OrderSessionSync />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/confirm-order" element={<ConfirmOrder />} />
          <Route path="/order-items/:id/:orderNumber" element={<OrderItems />} />
          <Route path="/order-details/:id/:orderNumber/:orderItemId" element={<OrderDetails />} />
        </Routes>
      </BrowserRouter>
      <Snackbar timeout={5000} />
    </div>
  );
}

export default App;
